import { render } from "./Newspaper.vue?vue&type=template&id=1735744a"
import script from "./Newspaper.vue?vue&type=script&lang=js"
export * from "./Newspaper.vue?vue&type=script&lang=js"
script.render = render

export default script